// Module
var code = " <h2> Which smart object for project 1 </h2> <p>Tell me which smart object you are going to work on.</p><p> </p><ul> <li>Smart shower</li> <li>Smart shopping cart</li> <li>Smart water bottle</li> <li>Smart toilet</li> <li>Smart flower pot / garden</li> <ul> </ul></ul>";
// Exports
export default code;